import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function WelcomePanel() {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/site-content').then(r => setContent(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put('/site-content', content); toast.success('Welcome screen saved'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
    finally { setSaving(false); }
  };

  if (!content) return <div className="text-brand-slate text-sm">Loading…</div>;

  const set = (k, v) => setContent({ ...content, [k]: v });
  const field = (k, label, multiline, hint) => (
    <div>
      <Label className="text-xs uppercase tracking-[0.2em] text-brand-dim">{label}</Label>
      {multiline
        ? <Textarea data-testid={`welcome-${k}`} value={content[k] || ''} onChange={e => set(k, e.target.value)} className="mt-2 rounded-xl min-h-[110px]" />
        : <Input data-testid={`welcome-${k}`} value={content[k] || ''} onChange={e => set(k, e.target.value)} className="mt-2 rounded-xl" />}
      {hint && <p className="text-xs text-brand-dim mt-1">{hint}</p>}
    </div>
  );

  return (
    <div data-testid="welcome-panel">
      <h2 className="font-display font-bold text-2xl text-brand-ink mb-1">Welcome screen</h2>
      <p className="text-brand-slate text-sm mb-6">The one-time onboarding shown to first-time users after they sign in.</p>
      <div className="glass-panel rounded-3xl p-6 space-y-5">
        {field('welcome_screen_title', 'Title')}
        {field('welcome_screen_intro', 'Intro paragraph', true)}
        {field('welcome_screen_features', 'Features', true, 'One feature per line — shown as a checklist.')}
        {field('welcome_screen_rules', 'Community rules', true, 'One rule per line — shown as bullets.')}
        {field('welcome_screen_agree_label', 'Agreement checkbox label')}
        <div className="pt-2 flex justify-end">
          <Button data-testid="welcome-save-btn" onClick={save} disabled={saving} className="rounded-full bg-brand hover:bg-brand-hover text-white px-6">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />} Save welcome screen
          </Button>
        </div>
      </div>
    </div>
  );
}
